export const VIEW_ALL_COMPONENT = 'view_all';
